import { Injectable } from '@angular/core';
import { SafeHtml, DomSanitizer } from '@angular/platform-browser';
import { CMSSettingsContentService } from '../cms/settings/content/cms-content.service';


@Injectable({
  providedIn: 'root'
})
export class MicroFrontEndService {
  public content: SafeHtml = '';
  public url = `http://127.0.0.1:8080`;

  constructor(
    private sanitizer: DomSanitizer,
    private cmsSettingsContentService: CMSSettingsContentService
  ) { }

  private loadStyles(url: string) {
    if (document.querySelectorAll(`link[href='${url}']`).length === 0) {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = url;
      document.head.appendChild(link);
    }
  }

  private loadScript(url: string) {
    if (document.querySelectorAll(`script[src='${url}']`).length === 0) {
      const script = document.createElement('script');
      script.src = url;
      document.head.appendChild(script);
    }
  }

  loadMicroFrontEnd(project: string) {
    this.cmsSettingsContentService.return(project).subscribe(response => {
      let url = this.url;
      if (response.items[0].data.url) {
        url = response.items[0].data.url.iv;
      }
      this.loadScript(`${url}/main.js`);
      this.loadStyles(`${url}/styles.css`);
    });
  }

  getContent(component: string) {
    return this.sanitizer.bypassSecurityTrustHtml(`<${component}></${component}>`);
  }
}
